import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  cancelChangeEmailToken,
  changeEmailToken,
  fetchReferer,
  loginAccountByChallenge,
  loginAccountByCompany,
  loginAccountByEmail,
  loginAccountByFacebook,
  loginAccountByGoogle,
  loginAccountError,
  registerAccountByEmail,
  registerAccountByFacebook,
  registerAccountByGoogle,
  registerAccountError,
  resendUnusualLoginEmail,
  setPasswordByEmail,
  setPasswordToken,
  setReturnUrl,
  setTrackingObject,
  updatePasswordToken,
  verifyUnusualLogin,
  goToLogin,
  registerAccountByApple,
  loginAccountByApple,
} from '../actions';
import { IAccountResponseError } from '../../account.data';
import { ITrackingObject } from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { Challenge } from '../models/sub-models';

@Injectable()
export class AccountDispatcher {
  constructor(private _store: Store<any>) {}

  fetchReferer(referralCode: string) {
    this._store.dispatch(fetchReferer(referralCode));
  }

  registerAccountByEmail(
    email: string,
    password: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      registerAccountByEmail(email, password, locale, trackingScreenName)
    );
  }

  registerAccountByGoogle(
    email: string,
    idToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      registerAccountByGoogle(email, idToken, locale, trackingScreenName)
    );
  }

  registerAccountByFacebook(
    email: string,
    idToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      registerAccountByFacebook(email, idToken, locale, trackingScreenName)
    );
  }

  registerAccountByApple(
    email: string,
    idToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      registerAccountByApple(email, idToken, locale, trackingScreenName)
    );
  }

  registerAccountError(
    error: IAccountResponseError | Error,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(registerAccountError(error, trackingScreenName));
  }

  setReturnUrl(returnUrl: string) {
    this._store.dispatch(setReturnUrl(returnUrl));
  }

  loginAccountByEmail(
    email: string,
    password: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      loginAccountByEmail(email, password, locale, trackingScreenName)
    );
  }

  loginAccountByFacebook(
    email: string,
    idToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      loginAccountByFacebook(email, idToken, locale, trackingScreenName)
    );
  }

  loginAccountByGoogle(
    email: string,
    idToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      loginAccountByGoogle(email, idToken, locale, trackingScreenName)
    );
  }

  loginAccountByApple(
    email: string,
    idToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      loginAccountByApple(email, idToken, locale, trackingScreenName)
    );
  }

  loginAccountByCompany(
    accountId: string,
    refreshToken: string,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      loginAccountByCompany(accountId, refreshToken, locale, trackingScreenName)
    );
  }

  loginAccountByChallenge(
    challenge: Challenge,
    locale: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      loginAccountByChallenge(challenge, locale, trackingScreenName)
    );
  }

  loginAccountError(
    error: IAccountResponseError | Error,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(loginAccountError(error, trackingScreenName));
  }

  setPasswordByEmail(email: string, locale: string) {
    this._store.dispatch(setPasswordByEmail(email, locale));
  }

  setPasswordToken(token: string, locale: string) {
    this._store.dispatch(setPasswordToken(token, locale));
  }

  updatePasswordToken(
    userId: string,
    token: string,
    password: string,
    locale: string
  ) {
    this._store.dispatch(updatePasswordToken(userId, token, password, locale));
  }

  changeEmailToken(token: string, locale: string) {
    this._store.dispatch(changeEmailToken(token, locale));
  }

  cancelChangeEmailToken(token: string, locale: string) {
    this._store.dispatch(cancelChangeEmailToken(token, locale));
  }

  resendUnusualLoginEmail(attemptId: string) {
    this._store.dispatch(resendUnusualLoginEmail(attemptId));
  }

  verifyUnusualLogin(attemptId: string, verificationCode: string) {
    this._store.dispatch(verifyUnusualLogin(attemptId, verificationCode));
  }

  setTrackingObject(trackingObject: ITrackingObject) {
    this._store.dispatch(setTrackingObject(trackingObject));
  }

  goToLogin() {
    this._store.dispatch(goToLogin());
  }
}
